import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { TTypeBid } from '../models/auction';

@Injectable({
  providedIn: 'root',
})
export class AuctionService {
  constructor(private http: HttpService) {}

  getAuction(): Observable<any> {
    return this.http.get<any>('auction/auction-bid/');
  }

  getAuctionWinner(page: any): Observable<any> {
    const params = new HttpParams().set(`page`, page);

    return this.http.get<any>('auction/auction-winner/', params);
  }

  postAuctionBid(animal: any, qtd_choice = 0): Observable<any> {
    let body = new HttpParams().set(`animal`, animal);

    if (qtd_choice > 0) body = body.set(`qtd`, qtd_choice);

    return this.http.post<any>('core/create-shopping-bid/', body);
  }

  postAuctionBidPre(animal: any, value: any): Observable<any> {
    const body = new HttpParams().set(`animal`, animal).set(`value`, value);

    return this.http.post<any>('core/create-pre-bid/', body);
  }

  postAuctionSuperBid(animal: any): Observable<any> {
    const body = new HttpParams().set(`animal`, animal);

    return this.http.post<any>('core/create-super-bid/', body);
  }

  sendPreBidOverta(animal: any, value: any, increment?: any) {
    const body = new HttpParams()
      .set(`animal`, animal)
      .set(`value`, value || 0)
      .set(`increment`, increment);

    // return this.http.post<any>('core/create-teste/', body);
    return this.http.post<any>('core/create-pre-bid/', body);
  }

  sendOnlineBidOverta(animal: any, value: any, increment?: any) {
    const body = new HttpParams()
      .set(`animal`, animal)
      .set(`value`, value || 0)
      .set(`increment`, increment);

    // return this.http.post<any>('core/create-teste/', body);
    return this.http.post<any>('core/create-online-bid/', body);
  }

  createSuperBid(animal: any) {
    const body = new HttpParams()
      .set(`animal`, animal)

      return this.http.post<any>('core/create-super-bid/', body);
  }

  sendBidOverrun(animal: any, value: any, increment?: any) {
    const body = new HttpParams()
      .set(`animal`, animal)
      .set(`value`, value.toFixed(0) || 0)
      .set(`increment`, increment)
      .set(`type`, 'LEILAO AO VIVO');

    // return this.http.post<any>('core/create-teste/', body);
    return this.http.post<any>('core/create-real-time-bid/', body);
  }

  getListBid(animal: any, status: string): Observable<any> {
    const options = new HttpParams()
      .set(`animal`, animal)
      .set(`status`, status);

    return this.http.get<any>('core/list-bid-by-animal/', options);
  }

  getAuctionTransaction(id_schedule_event: any): Observable<any> {
    const options = new HttpParams().set(`schedule_event`, id_schedule_event);

    return this.http.get<any>('core/get-auction-real-time-by-id/', options);
  }
}
